import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

interface IConnectSandataIndianaData {
  entity_guid: string;
  account: string;
  username: string;
  password: string;
  payer_id: string;
  payer_program: string;
}

const connectSandataIndiana = (postData: IConnectSandataIndianaData) => {
  const newEndpoints = endpoints.integrations.sandataIndiana.connect;
  return http().post(newEndpoints, postData);
};

export function useConnectSandataIndiana() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: connectSandataIndiana,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchIntegrationList'] });
      }
    },
  });
}
